import { useBitrix } from '@context/useBitrixUser/useBitrix';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CalculationsMenuStatus } from '../../../CalculationsMenu/components/CalculationsMenuStatus';
import { CALCULATIONS_MENU_ITEMS_LIMIT } from '../../../CalculationsMenu/consts';
import { DeleteFavoriteConfirmDialog } from '../DeleteFavoriteConfirmDialog';
import { FavoritesMenuItem } from '../FavoritesMenuItem';
import { getFavoriteProduct, getFavoriteSectionId } from '../../helpers';

/**
 * Пропсы компонента
 */
type FavoritesMenuListProps = {
  sectionId: string;
};

/**
 * Последние избранные расчеты раздела
 */
export const FavoritesMenuList = ({ sectionId }: FavoritesMenuListProps) => {
  const { t } = useTranslation(['DeliveryForm']);
  const { useBitrixUser } = useBitrix();
  const [{ favorites }] = useBitrixUser().useState(['favorites']);
  const [favoriteIdToDelete, setFavoriteIdToDelete] = useState<string | null>(null);

  const items = useMemo(
    () =>
      [...favorites]
        .reverse()
        .map((favorite) => ({ favorite, product: getFavoriteProduct(favorite) }))
        .filter(({ product }) => !!product && getFavoriteSectionId(product) === sectionId)
        .slice(0, CALCULATIONS_MENU_ITEMS_LIMIT),
    [favorites, sectionId]
  );

  return (
    <>
      {items.map(({ favorite, product }) => (
        <FavoritesMenuItem
          key={`favorites-menu-item--${favorite.id}`}
          product={product}
          onDelete={() => setFavoriteIdToDelete(favorite.id)}
        />
      ))}
      {items.length === 0 && (
        <CalculationsMenuStatus isLoading={false} emptyText={t('DeliveryForm:FavoritesEmpty')} />
      )}
      <DeleteFavoriteConfirmDialog
        favoriteId={favoriteIdToDelete}
        onClose={() => setFavoriteIdToDelete(null)}
      />
    </>
  );
};
